// extracted by mini-css-extract-plugin
export default {"contents":"fH-z","sectionHeading":"gH-z"};